<template>
  <div 
    class="text-custom-dark-gray d-flex align-center justify-between p-1 rounded-sm"
    style="background-color : #F0F0F5; "
  >
    <i
      class="far fa-clock mr-2 my-1"
      style="color:  #828282"
    />
    <Timer
      v-if="showTimer"
      v-model="timeRemaining"
      :time="challengeStartedAt"
    />
    <i
      :class="showTimer ? 'fa fa-eye-slash' : 'fa fa-eye'"
      class="ml-2 text-nitro cursor-pointer"
      @click="showTimer = !showTimer"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Timer from './Timer'

export default {
  components: {
    Timer,
  },
  data() {
    return {
      timeRemaining: 0,
      showTimer: true,
    }
  },
  computed: {
    ...mapGetters(['challenge']),
    challengeStartedAt() {
      return this.challenge.started_at ? this.$moment(this.challenge.started_at)
        .add(this.challenge.minutes, 'minutes')
        .valueOf() : null;
    },
  },
  watch: {
    timeRemaining(value) {
      if (value < 1000 && !this.challenge.finished_at) {
        this.end()
      }
      this.$emit('input', value);
    }
  },
}
</script>
